import { render, staticRenderFns } from "./ColorsList.vue?vue&type=template&id=54da947a"
import script from "./ColorsList.vue?vue&type=script&lang=js"
export * from "./ColorsList.vue?vue&type=script&lang=js"
import style0 from "./ColorsList.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports